<template>
  <SimonModal
    is-visible
    id="mfa-input-modal"
    customModalClass="mfa-input-modal"
    show-footer-buttons
    :btn-left-title="getSlotText('btnCancel')"
    :btn-right-title="getSlotText('btnSubmit')"
    disabled-close
    @btnLeft="onClose"
    @btnRight="onSubmit"
    @hide="onClose"
    :disabled-btn-right="!isCodeValid"
  >
    <template v-slot:modalTitle>
      <h3>
        <slot name="txtHeadline"></slot>
      </h3>
    </template>
    <p>
      <dyn-slot :slotData="slotData">
        <slot name="txtDescription"></slot>
      </dyn-slot>
    </p>
    <MfaCodeInput @updated="updateCode">
      <template v-for="slot in possibleChildSlotsFor('Code')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </MfaCodeInput>
  </SimonModal>
</template>

<script>
import SimonModal from '@/components/modal/SimonModal.vue'
import MfaCodeInput from '@/components/process/generic/Mfa/MfaCodeInput.vue'
import { mapActions, mapGetters } from 'vuex'
import trackingHandler from '@/mixins/trackingHandler'

const codeLength = 6

export default {
  name: 'MfaInput',
  components: {
    MfaCodeInput,
    SimonModal
  },
  data () {
    return {
      code: '',
      isCodeInvalid: false
    }
  },
  mixins: [trackingHandler],
  computed: {
    ...mapGetters('mfa', [
      'getMsisdn'
    ]),
    slotData () {
      return {
        msisdn: this.maskPhoneNumber('+' + this.getMsisdn)
      }
    },
    isCodeValid () {
      return this.code.length === codeLength
    }
  },
  methods: {
    ...mapActions('mfa', [
      'completeMfa'
    ]),
    maskPhoneNumber (phone) {
      const cleanPhone = phone.replace(/\s+/g, '')
      const lastFour = cleanPhone.slice(-4)

      const match = cleanPhone.match(/^(\+\d{2})(\d+)(\d{4})$/)

      if (match) {
        const prefix = match[1]
        const masked = '*'.repeat(match[2].length)
        return `${prefix} ${masked} ${lastFour}`
      }

      return phone
    },
    updateCode (code) {
      this.code = code
      this.isCodeInvalid = false
    },
    onClose () {
      this.code = ''
      this.$emit('close')
    },
    async onSubmit () {
      if (!this.isCodeValid) {
        this.isCodeInvalid = true
        return
      }

      try {
        await this.completeMfa(this.code)
        this.$emit('completed')
      } catch (error) {
        this.errorToast(this.getErrorMessage(error))
        this.triggerErrorTracking(error)
      }
    }
  }
}
</script>
